import { ReactNode } from 'react';

import {
  layoutClassName,
  leftPanelClassName,
  mainContentClassName,
  rightPanelClassName,
} from './styles';

interface Props {
  children: ReactNode;
  rightPanel: ReactNode;
}

const Layout = ({ children, rightPanel }: Props) => {
  return (
    <div className={layoutClassName}>
      <div className={leftPanelClassName}>
        <main className={mainContentClassName}>{children}</main>
      </div>
      <div className={rightPanelClassName}>{rightPanel}</div>
    </div>
  );
};

Layout.displayName = 'Layout';

export default Layout;
